import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';



const PageTitleSection = styled.section.attrs({className: 'page-title-section'})`
    max-width: var(--contents-maxwidth-pc);
    margin-right:auto;
    margin-left:auto;
    @media (max-width: 768px) {
      margin: 0;
    }
    @media (min-width: 769px) {
      width:95%;
    }
`;

const PageTitleMain = styled.h1.attrs({className: 'page-title'})`
  font-family: 'A P-OTF Aoto Gothic StdN', 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 56px;
  line-height: 1;
  letter-spacing: 0.05em;
  color: #333333;
  margin: 0 0 16px 0;

  @media (max-width: 768px) {
    font-size: 44px;
    line-height: 1.5;
    margin: 0 0 12px 0;
  }
`;

const PageTitleSub = styled.h2.attrs({className: 'page-subtitle'})`
  font-family: 'ITC Avant Garde Gothic Pro', 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
  letter-spacing: 0.05em;
  color: #9B9B9B;
  margin: 0;
  font-style: italic;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;



type Props = {
  title: string;
  subtitle: string;
};


export const PageTitle = ({ title, subtitle }: Props) => {
  return (
    <PageTitleSection>
      <PageTitleMain>{title}</PageTitleMain>
      <PageTitleSub>{subtitle}</PageTitleSub>
    </PageTitleSection>
  );
};

export default PageTitle;
